module.exports = __webpack_public_path__ + "static/img/6.c3c751a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user-center/my-focus/6.jpg
// module id = VCKr
// module chunks = 1